import { CreateEvaluateTestSetJobViewModel, useGetApiChatBotDataList } from "@/API";
import { Button, Group, Modal, NumberInput, Select, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function CreateEvaluateTestSetJobButton(props: { workspaceId: string, onSubmit?: (value: CreateEvaluateTestSetJobViewModel) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const chatBotDataList = useGetApiChatBotDataList({ workspaceId: props.workspaceId })

    const form = useForm<CreateEvaluateTestSetJobViewModel>({
        initialValues: {
            repeatCount: 1,
        },
        validate: {
            repeatCount: (value) =>
                value === undefined || value === null
                    ? "請輸入重複測試次數"
                    : value < 1 || value > 10
                    ? "重複測試次數必須介於 1 至 10 之間"
                    : null,
        },
    });

    useEffect(() => {
        if (opened) form.reset()
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="建立評估工作">
            <form onSubmit={form.onSubmit((values) => {
                console.log(values)
                props.onSubmit?.(values)
                close()
            })}>
                <Stack>
                    <Select
                        label="機器人設定"
                        searchable
                        data={chatBotDataList.data?.data.results?.filter(x => !!x.id).map(x => {
                            return {
                                label: x.name ?? "",
                                value: x.id ?? ""
                            }
                        })}
                        {...form.getInputProps('chatBotDataId')}
                    />
                    <NumberInput
                        label="重複測試次數"
                        description="同一個測試題目將反覆測試指定的次數以取平均，提升評估穩定性"
                        min={1}
                        max={10}
                        {...form.getInputProps('repeatCount')}
                    />
                </Stack>
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}
